export const HOME = {
    header: "site-header",
    headerLogo: "header-logo",
    headerNavLink: (slug) => `header-nav-${slug}`,
    headerSpotifyCta: "header-spotify-cta",

    hero: "hero-section",
    heroLogo: "hero-logo",
    heroTitle: "hero-title",
    heroTagline: "hero-tagline",
    heroLane: "hero-lane",
    heroSpotifyCta: "hero-spotify-cta",
    heroSubmitLink: "hero-submit-link",

    playlists: "playlists-section",
    spotifyPanel: "spotify-panel",
    spotifyEmbed: "spotify-embed",
    spotifyFollowCta: "spotify-follow-cta",
    spotifyFallback: "spotify-fallback",
    mirrors: "playlist-mirrors",
    mirrorsNote: "mirrors-note",
    appleCta: "apple-cta",
    soundcloudCta: "soundcloud-cta",

    about: "about-section",
    aboutBody: "about-body",

    submit: "submit-section",
    submitForm: "submit-form",
    submissionTypeReleased: "submission-type-released",
    submissionTypeUnreleased: "submission-type-unreleased",
    fieldArtist: "field-artist-name",
    fieldFirstName: "field-first-name",
    fieldTrack: "field-track-name",
    fieldUrl: "field-track-url",
    fieldReleaseDate: "field-release-date",
    fieldPrivateUrl: "field-private-url",
    fieldGenre: "field-genre",
    fieldEmail: "field-email",
    fieldNote: "field-note",
    fieldHoneypot: "field-honeypot",
    submitButton: "submit-button",
    submitSuccess: "submit-success",
    submitError: "submit-error",
    fieldErrorFor: (name) => `error-${name}`,

    faq: "faq-section",
    faqItem: (i) => `faq-item-${i}`,

    follow: "follow-section",
    instagramCta: "instagram-cta",
    followSpotifyCta: "follow-spotify-cta",
    followAppleCta: "follow-apple-cta",
    followSoundcloudCta: "follow-soundcloud-cta",

    footer: "site-footer",
    footerContact: "footer-contact",
};
